import { useEffect, useState } from "preact/hooks";
import AggregatedOverview from "../AggregatedOverview";
import Events from "../Events";
import Visits from '../Visits';
import Sources from "../Sources";
import Pages from "../Pages";
import Devices from "../Devices";
import Regions from "../Regions";
import Conversions from "../Conversions";
import { clearDashboardFilters, dashboardFilters, dateRangePreset, getDashboardFilterLabel, removeDashboardFilter } from "../state";
import type { DashboardFilterField } from "../state";

const LIVE_REFRESH_INTERVAL_MS = 5000;

const Dashboard = () => {
    const [liveRefreshTick, setLiveRefreshTick] = useState(0);
    const activeFilters = Object.entries(dashboardFilters.value).flatMap(([field, values]) =>
        (values ?? []).map((value) => ({
            field: field as DashboardFilterField,
            value,
        }))
    );

    useEffect(() => {
        if (dateRangePreset.value !== "live") {
            return;
        }

        const intervalId = window.setInterval(() => {
            setLiveRefreshTick((current) => current + 1);
        }, LIVE_REFRESH_INTERVAL_MS);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [dateRangePreset.value]);

    return (
        <div className="dashboard-container">
            <div className="dashboard-filter-bar">
                <div>
                    <h2 className="section-title">Filtri dashboard</h2>
                    <p className="section-note">
                        Clicca una voce nei report per filtrare tutta la dashboard, in stile drill-down.
                    </p>
                </div>
                <div className="dashboard-filter-actions">
                    {activeFilters.length > 0 && (
                        <button className="pagination-btn" onClick={() => clearDashboardFilters()}>
                            Reset filtri
                        </button>
                    )}
                </div>
            </div>

            {activeFilters.length > 0 && (
                <div className="dashboard-filter-chips">
                    {activeFilters.map((filter) => (
                        <button
                            key={`${filter.field}-${filter.value}`}
                            className="dashboard-filter-chip"
                            onClick={() => removeDashboardFilter(filter.field, filter.value)}
                            title="Rimuovi filtro"
                        >
                            <span className="dashboard-filter-chip-label">
                                {getDashboardFilterLabel(filter.field)}:
                            </span>
                            <span>{filter.value}</span>
                            <span aria-hidden="true">×</span>
                        </button>
                    ))}
                </div>
            )}

            <section className="dashboard-section">
                <div className="section-header">
                    <h2 className="section-title">Statistiche Aggregate</h2>
                    <p className="section-note">
                        Dati anonimi disponibili anche senza consenso: pageview, eventi custom, pagine, referrer e campagne UTM.
                    </p>
                </div>
                <AggregatedOverview liveRefreshTick={liveRefreshTick} />
                <div className="stats-grid">
                    <Events liveRefreshTick={liveRefreshTick} />
                    <Pages liveRefreshTick={liveRefreshTick} />
                </div>
            </section>

            <section className="dashboard-section">
                <div className="section-header">
                    <h2 className="section-title">Analisi Sessioni</h2>
                    <p className="section-note">
                        Questi report richiedono consenso e identificativo pseudonimo.
                    </p>
                </div>
                <Visits liveRefreshTick={liveRefreshTick} />
                <div className="stats-grid">
                    <Sources liveRefreshTick={liveRefreshTick} />
                    <Devices liveRefreshTick={liveRefreshTick} />
                </div>
                <div className="stats-grid">
                    <Regions liveRefreshTick={liveRefreshTick} />
                </div>
                <Conversions />
            </section>
        </div>
    );
};

export default Dashboard;
